import { getProgramPatientsPaged, deletePatient } from '@bforms-web/common';

import ProgramsPatientsList, { ProgramPatientsListProps } from '../../components/Patient/List';

const dispatchers: Pick<ProgramPatientsListProps, 'getProgramPatientsPaged' | 'deletePatient'> = {
  getProgramPatientsPaged,
  deletePatient,
};

export default function UserListComposer(): JSX.Element {
  return <ProgramsPatientsList {...dispatchers} />;
}
